import { ThemeProps, ThemeTokens } from '@atlaskit/button/types';
import type { SearchCSS } from '@atlaskit/atlassian-navigation';

export const getIconButtonTheme = (iconButton: SearchCSS) => (
  current: (props: ThemeProps) => ThemeTokens,
  props: ThemeProps,
): ThemeTokens => {
  const { buttonStyles, spinnerStyles } = current(props);

  return {
    buttonStyles: {
      ...buttonStyles,
      borderRadius: '100%',
      display: 'flex',
      margin: '0 2px',
      padding: 4,
      height: 'auto',
      fontWeight: 500,
      ...iconButton.default,
      ':hover': { ...iconButton.hover },
      ':focus': { ...iconButton.focus },
    },
    spinnerStyles,
  };
};
